import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import { loadState } from '@utils/localStorage';
import wishlistReducer from './wishlist/wishlistSlice';

const persistedState = loadState();

export const store = configureStore({
  reducer: {
    wishlist: wishlistReducer,
  },
  preloadedState: persistedState,
  devTools:
    process.env.NODE_ENV !== 'prod' && window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : undefined,
  middleware: [thunk],
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
